const controller = "settings/clients/bitrix";

export default {
  controller,
  search: controller + "/search",
  regular: controller + "/regular",
  byId: (id: number) => controller + `/${id}`,
};
